// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { jsx } from 'panel';
import { SvgIconEl } from 'common/components/svg-icon';
import { TooltipEl } from 'common/components/tooltip';
import { Placement } from 'common/components/tooltip/types';
export const FieldLabel = (_ref: {
  fieldName: string;
  tooltipText?: string;
  subLabel?: string;
}) => {
  let {
    fieldName,
    tooltipText = null,
    subLabel = null
  }: {
    fieldName: string;
    tooltipText?: string;
    subLabel?: string;
  } = _ref;
  return <div sel='.pre-selected-events' data-sentry-component="FieldLabel" data-sentry-source-file="FieldLabel.tsx">
      <div sel='.pre-selected-events-text'>
        {fieldName}
        {subLabel ? <span sel='.pre-selected-events-sublabel'>{subLabel}</span> : <></>}
      </div>
      {tooltipText && <div sel='.info-icon-wrapper'>
          <SvgIconEl sel='.info-icon' attrs={{
        icon: "info"
      }} />
          <TooltipEl sel='.info-icon-tooltip' attrs={{
        'max-width': "260px",
        placement: Placement.RightCenter,
        text: tooltipText
      }} />
        </div>}
    </div>;
};